
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class extends Vue {
  @Prop() title!: string

  url: string = process.env.WEB_PUSH_URL + this.$route.fullPath
  socials: any = {
    vk: 'https://vk.com/share.php?url=' + encodeURIComponent(this.url) + '&title=' + encodeURIComponent(this.title),
    fb: 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(this.url) + '&title=' + encodeURIComponent(this.title),
    ok: 'https://connect.ok.ru/offer?url=' + encodeURIComponent(this.url) + '&title=' + encodeURIComponent(this.title),
    tw: 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.title) + '&url=' + encodeURIComponent(this.url)
  }

  openNewWindow (url: string) {
    window.open(url, '', 'Toolbar=1,Location=0,Directories=0,Status=0,Menubar=0,Scrollbars=0,Resizable=0,Width=550,Height=400')
  }
}
